import {
  OuiCenterComponent,
  OuiGridComponent,
  OuiStackComponent,
  OuiSymbolComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';

import { Component, signal } from '@angular/core';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-dashboard',
  imports: [
    OuiGridComponent,
    OuiTextComponent,
    OuiStackComponent,
    OuiSymbolComponent,
    OuiCenterComponent,
  ],
  templateUrl: './dashboard.html',
})
export class DashboardPage extends BasePageComponent {
  constructor() {
    super();
  }

  dashboardItems = signal([
    {
      title: "Today's Orders",
      value: 12456,
      symbol: 'receipt_long',
      route: '/orders',
    },
    {
      title: 'Completed Orders',
      value: 12456,
      badges: ['new'],
      symbol: 'order_approve',
      route: '/ecommerce',
    },
    {
      title: 'Orders in Progress',
      value: 12456,
      symbol: 'deployed_code_history',
      route: '/orders',
    },
    {
      title: 'Cancel Orders',
      value: 12456,
      badges: ['new'],
      symbol: 'deployed_code_alert',
      route: '/ecommerce',
    },
    {
      title: "Today's Orders",
      value: 12456,
      symbol: 'order_approve',
      route: '/orders',
    },
    {
      title: 'Completed Orders',
      value: 12456,
      badges: ['new'],
      symbol: 'list_alt_check',
      route: '/ecommerce',
    },
    {
      title: "Today's Orders",
      value: 12456,
      symbol: 'order_approve',
      route: '/orders',
    },
    {
      title: 'Completed Orders',
      value: 12456,
      badges: ['new'],
      symbol: 'list_alt_check',
      route: '/ecommerce',
    },
  ]);
}
